import * as z from "zod";

export const changePasswordStep2Schema = z.object({
    password: z
    .string()
    .min(4, "비밀번호는 최소 4자 이상이어야 합니다."),
    confirmPassword: z
    .string()
    .min(4, "비밀번호는 최소 4자 이상이어야 합니다."),
});

// 🔹 타입 정의
export type ChangePasswordStep2FormValues = z.infer<typeof changePasswordStep2Schema>;